import { render, staticRenderFns } from "./PUserContext.vue?vue&type=template&id=00f81c3c"
import script from "./PUserContext.vue?vue&type=script&lang=js"
export * from "./PUserContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports